var map = {
	"./de.png": "IxZ1",
	"./en.png": "6wLs",
	"./es.png": "6FvI",
	"./fr.png": "yhGn",
	"./ja.png": "C+1U",
	"./ko.png": "Kq7g",
	"./pt.png": "2Dwm",
	"./ru.png": "uI3Y",
	"./th.png": "P8fI",
	"./zh-Hant.png": "Pbwc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5rl6";